import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux-immutable';
import { List, fromJS } from 'immutable';
import { setOutcomeList } from './actions';
import paginationReducer from '../utils/paginationReducer';
var list = handleActions(_defineProperty({}, setOutcomeList, function (state, action) {
  return fromJS(action.payload);
}), List());
export default combineReducers({
  list: list,
  pagination: paginationReducer('LIST')
});